import { fetchAPI } from "../utils/fetchAPI";

import { API_ROUTES, API_METHODS } from "../constants/api";

export const getParsedLinkInfo = (link) => {
  return fetchAPI(`${API_ROUTES.getParsedLinkInfo}${link}`, API_METHODS.get)
}